import * as actions from '../../../actions/assessments/budget'
import * as h2Api from '../../../h2Api'

const initialState = h2Api.handleRest()
const reverseWage = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOAD_WAGE_FOR_REVERSE:
      return {
        ...state,
        ...h2Api.handleRest(action)
      }

    default:
      return state
  }
}

export default reverseWage
